<script setup>
const props = defineProps({
  category: { type: String, required: true },
  label: { type: String, required: true }
})
defineEmits(['clickRadarLinkButton'])
</script>

<template>
  <button
    :data-weather="props.category"
    :data-selected="props.category === 'kosa'"
    @click="$emit('clickRadarLinkButton')"
  >
    <span>
      <figure>
        <img
          :src="`https://gvs.weathernews.jp/onebox/radar/img/icon/icon_${props.category}_v2.svg`"
          width="24"
          height="24"
          alt=""
        >
      </figure>
    </span>
    <span>{{ props.label }}</span>
  </button>
</template>

<style lang="scss" scoped>
</style>
